import script from "./CheckoutCounterPayStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutCounterPayStatus.vue?vue&type=script&setup=true&lang=js"

import "./CheckoutCounterPayStatus.vue?vue&type=style&index=0&id=b34a5846&scoped=true&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b34a5846"]])

export default __exports__